import { graphql } from "gatsby";
import Image from "gatsby-image";
import parse from "html-react-parser";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { Toaster } from "react-hot-toast";

import "./faq.scss";

import BreadCrumb from "../../components/BreadCrumb/breadCrumb";
import ContactSupport from "../../components/ContactSupport/contactSupport";
import CTALabel from "../../components/CTALabel/ctaLabel";
import FeedbackSurvey from "../../components/FeedbackSurvey/feedbackSurvey";
import Header from "../../components/Header/header";
import PageList from "../../components/PageList/pageList";
import SideNavbar from "../../components/SideNavbar/sideNavbar";
import VerticalLine from "../../components/VerticalLine/verticalLine";

import { isTokenPresent } from "../../utils/cookieHelper";
import contentParserOptions from "../../utils/parser";
import {
  CONTACT_SUPPORT_STATUS,
  EVENTS,
} from "../../utils/constants";
import {
  ingestData,
  isMobile,
} from "../../bridges/BridgeServices";
import SearchInput from "../../components/SearchInput/searchInput";
import MobileHeader from "../../components/MobileHeader/mobileHeader";
import { isShowWebHeader } from "../../utils/helperFunctions";

const Faq = ({
  data: {
    wpPage: {
      uri = "",
      featuredImage = {},
      content = "",
      categoryAndTag = "",
    } = {},
  },
  pageContext: {
    allPagesData = {},
    searchDataArrayObject = [],
  },
}) => {
  const {
    feedbackSurvey = false,
    "related-queries": relatedQueries = [],
    title = "",
    seoTitle,
    seoMetaDesc,
    contactSupport,
    ctaDetails,
  } = allPagesData[uri] || {};
  const isContactSupportCTA =
    contactSupport === CONTACT_SUPPORT_STATUS.YES;

  useEffect(() => {
    ingestData({
      name: EVENTS.FAQ_LANDED,
      data: {
        categoryAndTag: categoryAndTag?.categoryAndTag,
        faqTitle: title,
      },
    });
  });

  return (
    <>
      <Toaster position="bottom-center" />
      <Header
        title={seoTitle}
        description={seoMetaDesc}
        searchData={searchDataArrayObject}
        pageURI={uri}
      />
      {/* adding an extra div for server side rendering */}
      <div className="mobile-search-input-wrapper">
        {isMobile() ? (
          isShowWebHeader() ? (
            <MobileHeader
              variant="compressed"
              faqTitle={title}
            />
          ) : (
            <SearchInput data={searchDataArrayObject} />
          )
        ) : null}
      </div>
      <BreadCrumb uri={uri} allPagesData={allPagesData} />
      <div className="faq-grid">
        <SideNavbar uri={uri} allPagesData={allPagesData} />
        <VerticalLine />
        <div className="faq-page">
          <div className="faq-page-div">
            <div className="faq-title">{title}</div>
            <div className="faq-featured-image">
              <Image
                fluid={
                  featuredImage?.node?.localFile
                    ?.childImageSharp?.fluid
                }
                alt={"Page Featured Image"}
              />
            </div>
            <div className="faq-content">
              {content &&
                parse(content, contentParserOptions)}
            </div>

            {feedbackSurvey && (
              <FeedbackSurvey
                categoryAndTag={categoryAndTag}
                faqTitle={title}
              />
            )}
          </div>
          <PageList
            allPagesData={allPagesData}
            pages={relatedQueries}
            heading="Related Queries"
            showIcon={false}
            categoryAndTag={categoryAndTag?.categoryAndTag}
          />
          {isContactSupportCTA && isTokenPresent() && (
            <ContactSupport faqTitle={title} />
          )}
          {ctaDetails && isTokenPresent() && (
            <CTALabel faqTitle={title} {...ctaDetails} />
          )}
        </div>
      </div>
    </>
  );
};

Faq.propTypes = {
  data: PropTypes.object,
  pageContext: PropTypes.object,
};

export default Faq;

export const query = graphql`
  query FaqPageById($id: String!) {
    wpPage(id: { eq: $id }) {
      uri
      content
      categoryAndTag {
        categoryAndTag
      }
      featuredImage {
        node {
          localFile {
            childImageSharp {
              fluid {
                srcSet
              }
            }
          }
        }
      }
    }
  }
`;
